<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">

            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <b-button size="sm" variant="success" v-on:click="excelDownloadForm()" class="exceldown_button"><h5 style="margin-bottom:0px"><i class="fa fa-file-excel-o"></i> 엑셀다운로드</h5></b-button>
                <span style="color:#8c8872; font-weight:bold; font-size:15px">* 아래 정보를 다운받으실수 있습니다.</span>
              </b-col>
              <b-col sm="5"></b-col>
              <b-col md="3" class="my-1">
                <b-row>
                  <b-col sm="8"/>
                  <b-col sm="4">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </b-col>


          <b-col v-if="isLoading" sm="12">
            <div class="text-center loadingbar" style="margin:300px 0 350px 0">
              <div style="width:200px; margin:0 auto; vertical-align:middle">
                <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
              </div>
            </div>
          </b-col>

          <b-col v-else sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>

                  <template slot="top_type_name" slot-scope="data">
                    <div style="width:90px">{{data.item.top_type_name}}</div>
                  </template>

                  <template slot="type_name" slot-scope="data">
                    <div style="width:100px">{{data.item.type_name}}</div>
                  </template>

                  <template slot="report_name" slot-scope="data">
                    <div style="width:320px"><a href="javascript:void(0)" v-tooltip.top-center="data.item.report_name" v-on:click="contentStatisticsInfoGo(data.item)">{{data.item.report_name}}</a></div>
                  </template>

                  <template slot="dr_opt_name" slot-scope="data">
                    <div style="width:120px" v-tooltip.top-center="data.item.dr_opt_name != '-' ? data.item.dr_opt_name : ''">{{data.item.dr_opt_name != null ? (data.item.dr_opt_name.length > 20 ? data.item.dr_opt_name.substring(0, 20)+' . . .' : data.item.dr_opt_name) : '이전 데이터'}}</div>
                  </template>

                  <template slot="custom_date" slot-scope="data">
                    <div>{{data.item.custom_date}}</div>
                  </template>

                  <template slot="report_reg_date" slot-scope="data">
                    <div>{{data.item.report_reg_date}}</div>
                  </template>

                  <template slot="sales_name" slot-scope="data">
                    <div>
                      <span class="badge badge-success" style="font-size:15px" v-show="data.item.sales_type == 'free'">무료</span>
                      <span class="badge badge-danger" style="font-size:15px" v-show="data.item.sales_type == 'pay'">유료</span>
                    </div>
                  </template>

                  <template slot="price_or_point" slot-scope="data">
                    <div v-show="data.item.sales_type == 'free'">무료</br>(<span style="width:17px; height:17px; background:#fff; font-weight:bold; font-size:10px; text-align:center; color:#ff500f; border-radius:20px; border:2px solid #ff500f; display:inline-block">R</span> {{Number(data.item.report_point_minus).toLocaleString()}})</div>
                    <div v-show="data.item.sales_type == 'pay'">
                      {{('￦ '+Number(data.item.min_price).toLocaleString())}}<br/>
                      {{(' ~ ￦ '+Number(data.item.max_price).toLocaleString())}}
                    </div>
                  </template>

                  <template slot="HEAD_unique_dl_cnt" slot-scope="data" v-show="false">
                    <div><span>다운로드</br>(중복제거)</span></div>
                  </template>

                  <template slot="reg_info" slot-scope="data">
                    <div>{{data.item.reg_id}}</br>({{data.item.reg_name}})</div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>


import cSwitch from '../../../../../components/Switch'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'DrList',
  props: {
    queryParams: {
      type: Object
    },
    fieldItems: {
      type: Array
    },
    fullDate: {
      type: Array
    },
  },

  components: {
    PulseLoader,
    cSwitch
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindContent", () => {
      this.findContentStatisticsList();
    });
  },
  data () {
    return {
      drDeleteRows: [],
      selectSlotNumbers: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      selectAll: false,
      slotParams: {},
      items: [],
      excelTotalCnt: 0,
      isLoading: true,

      active_view_type:'VIEW', //검색 버튼을 눌렀을 때 활성화된 VIEW_TYPE
      active_start_date: '',
      active_end_date: '',
    }
  },
  mounted() {
    this.queryParams.report_type_code   = 'all';
    this.queryParams.sales_type    = 'all';
    this.queryParams.view_type    = 'VIEW';
    this.queryParams.keyword = '';
    this.findContentStatisticsList();
  },
  methods: {
    // 검색 리스트 불러오기
    findContentStatisticsList() {
      var self = this;
      self.isLoading = true;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      this.$parent.chagefield(this.queryParams.view_type);

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/contentStatisticsList?access_token=' + token, data, null)
        .then((result) => {

          self.active_view_type = self.queryParams.view_type;
          self.active_start_date = self.queryParams.start_date;
          self.active_end_date = self.queryParams.end_date;

          self.items = result.data.statisticsList;
          self.excelTotalCnt = result.data.excel_total;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
          });


          self.isLoading = false;


        })
      self.$session.set('queryParamsInfo', JSON.stringify(self.queryParams));
      // JSON.parse(localStorage.cartItems).length;
    },

    contentStatisticsInfoGo(row) {
      var self = this;
      self.$session.set('reportDrcode', row.dr_code);
      self.$session.set('reportInfoName', row.report_name);
      location.href = '#/statis/contentStatistics/info';
    },

    excelDownloadForm(){
      var self = this;

      if (self.isLoading){
        swal.fire('아직 데이터를 불러오지 못했습니다.', '', 'warning').then(function() {
        });
        return;
      }

      var authKeyTable = "";
      authKeyTable += '<section class="container_login loginbox" style="margin:0px auto">';
      authKeyTable += '    <dl style="margin-top:32px">';
      authKeyTable += '        <dd>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:17px">현재 아래의 기준으로 다운로드 됩니다.</p>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:20px; color:#ff6863">';
      authKeyTable += '             현재 데이터수(중복포함) : <span style="color:#ea0000; font-weight:bold">'+Number(self.excelTotalCnt).toLocaleString()+'</span>';
      authKeyTable += '            </p>';
      authKeyTable += '        </dd>';
      authKeyTable += '    </dl>';
      authKeyTable += '    <section class="container_join" style="margin:0px; padding:0px">';
      authKeyTable += '       <h2 style="border-top:4px solid #222; padding-top:20px"></h2>';
      authKeyTable += '       <dl style="padding:0px 10px">';
      var viewcodename = '';
      if(self.active_view_type == 'VIEW'){
        viewcodename = '조회';
      }else if(self.active_view_type == 'DOWNLOAD'){
        viewcodename = '다운로드';
      }else if(self.active_view_type == 'RECOMMAND'){
        viewcodename = '추천';
      }else if(self.active_view_type == 'RESEARCH'){
        viewcodename = '후속연구요청수';
      }

      authKeyTable += '         <dt style="width:35%; font-size:20px">조회 구분</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+viewcodename+'</dd>';
      authKeyTable += '         <dt style="width:35%; font-size:20px">검색된 기간</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+(self.active_start_date ? self.active_start_date+' ~ '+self.active_end_date : '전체')+'</dd>';
      authKeyTable += '       </dl>';
      authKeyTable += '    </section>';
      authKeyTable += '</section>';

      swal.fire({
        title: '엑셀다운로드!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: authKeyTable,
        type: 'warning',
        showConfirmButton: true,
        // onOpen: function (){
        //
        // },
        confirmButtonColor: '#ff500f',
        confirmButtonText: 'DOWNLOAD',
        onBeforeOpen: () => {
          const content = swal.getContent()
          const $ = content.querySelector.bind(content)
        },
      }).then((swalResult) => {
        if (swalResult.value) {
          // console.log(self.userkeyParams);
          var resultTable = "";
          resultTable += '<table class="r-point" cellspacing="0" style="margin-top: 15px">';
          resultTable += '  <tr>';
          resultTable += '    <th width="120">총 데이터수</th>';
          resultTable += '    <td>'+Number(self.excelTotalCnt).toLocaleString()+'</td>';
          resultTable += '  </tr>';
          resultTable += '  <tr>';
          resultTable += '    <th>파일 형식</th>';
          resultTable += '    <td>.xlsx</td>';
          resultTable += '  </tr>';
          resultTable += '</table>';

          swal.fire({
            // type: 'success',
            title: '다운로드 중 ..',
            html: resultTable,
            showConfirmButton: false,
            allowOutsideClick: false,
            // timer: 2000,
            onOpen: function (){
              swal.showLoading();
              var filenames = '콘텐츠_통계(일반)';
              if(self.active_view_type == 'VIEW'){
                filenames += '_조회';
              }else if(self.active_view_type == 'DOWNLOAD'){
                filenames += '_다운로드';
              }else if(self.active_view_type == 'RECOMMAND'){
                filenames += '_추천';
              }else if(self.active_view_type == 'RESEARCH'){
                filenames += '_후속연구요청';
              }

              if(self.active_start_date){
                filenames += '_('+self.active_start_date+' ~ '+self.active_end_date+').xlsx';
              }else{
                filenames += '_전체.xlsx';
              }

              self.queryParams.excel_rtype = 'DR';
              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.queryParams));
              var datas = new FormData();
              datas.append('objs', param);
              // data.append('fileurl', self.reportDataItems.abridgement_downlink);
              // data.append('filedowntype', "SAMPLEFILE");
              self.$http.post('/api/excel/excelDownload?access_token=' + token, datas, { responseType: 'blob'})
                .then((result) => {
                  var blob = result.data;
                  if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
                    window.navigator.msSaveOrOpenBlob(blob, filenames);
                  }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    document.body.appendChild(link);//For FireFox <a> tag event
                    //not working
                    link.click();
                  }else{
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    link.click();
                  }
                  swal.close();
                })
            },
          }).then(function() {
            swal.fire(
              '다운로드 완료',
              '',
              'success'
            ).then(function() {

            });
          });
        }
      })
    },
    exceldownload(){
      var self = this;
      var filenames = '콘텐츠_통계(일반)';
      if(self.active_view_type == 'VIEW'){
        filenames += '_조회';
      }else if(self.active_view_type == 'DOWNLOAD'){
        filenames += '_다운로드';
      }else if(self.active_view_type == 'RECOMMAND'){
        filenames += '_추천';
      }else if(self.active_view_type == 'RESEARCH'){
        filenames += '_후속연구요청';
      }

      if(self.active_start_date){
        filenames += '_('+self.active_start_date+' ~ '+self.active_end_date+').xlsx';
      }else{
        filenames += '_전체.xlsx';
      }

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var datas = new FormData();
      datas.append('objs', param);
      self.$http.post('/api/excel/excelDownload?access_token=' + token, datas, { responseType: 'blob'})
        .then((result) => {
          var blob = result.data;
          if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
            window.navigator.msSaveOrOpenBlob(blob, filenames);
          }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filenames;
            document.body.appendChild(link);//For FireFox <a> tag event
            //not working
            link.click();
          }else{
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filenames;
            link.click();
          }
        })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/DrStatistics/DrList.vue